import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export const WaitingJobs = () => {
  const [c, setC] = useState(null);
  useEffect(() => {
    const load = () => api.get("/jobs/counts").then((r) => setC(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);
  if (!c || !(c.waiting || c.escalated || c.gaps)) return null;
  const parts = [c.waiting ? `${c.waiting} job${c.waiting > 1 ? "s" : ""} waiting for a rider` : "", c.escalated ? `${c.escalated} not accepted` : "", c.gaps ? `${c.gaps} rota gap${c.gaps > 1 ? "s" : ""} in the next 24h` : ""].filter(Boolean);
  return (
    <Link to="/dispatch" data-testid="waiting-jobs-banner" className="flex min-h-16 items-center justify-between gap-3 rounded-2xl bg-destructive px-5 py-3 font-bold text-white">
      <span>{parts.join(" · ")}</span>
      <span className="shrink-0 rounded-full bg-white px-4 py-1.5 text-sm text-black">Open Dispatch</span>
    </Link>
  );
};
